import { render, staticRenderFns } from "./CardEvergreen.vue?vue&type=template&id=28e8805d&"
import script from "./CardEvergreen.vue?vue&type=script&lang=js&"
export * from "./CardEvergreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports